export default [
  {
    path: "/reportInfo",
    name: "reportInfo",
    meta: {
      title: "数据概览",
    },
    component: () => import("./info.vue")
  },
  {
    path: "/reportCustomer",
    name: "reportCustomer",
    meta: {
      title: "客户详情",
    },
    component: () => import("./customer.vue")
  },
  {
    path: "/reportTrace",
    name: "reportTrace",
    meta: {
      title: "数据追踪",
      requireAuth: true
    },
    component: () => import("./reportTrace.vue")
  },
  {
    path: "/reportTraceDetail",
    name: "reportTraceDetail",
    meta: {
      title: "猎企详情",
      requireAuth: true
    },
    component: () => import("./reportTraceDetail.vue")
  }
];




